import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';
import { toFixedSafe } from '../../../lib/styles/perttierNumber';

const SideCoverForm = ({ onSaveStructure, onChangeWeightSummary, sideCovers }) => {
    const [isShow, setIsShow] = useState(sideCovers?.length || false);
    const [newSideCover, setNewSideCover] = useState(sideCovers ? sideCovers : []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [sectionCategory, setSectionCategory] = useState('1.0');
    // const [category2, setCategory2] = useState('');
    const [thickness, setThickness] = useState(1.5);
    const [height, setHeight] = useState(1500);
    const [length, setLength] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalLength, setTotalLength] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /*  처음 props로 넘어온 sideCovers를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialSideCover = useRef(sideCovers ? sideCovers : []);

    /* Category-I */
    const sectionCategoryText = useRef({
        1: 'Single Side',
        2: 'Both Side',
    });

    /* 단위 중량의 계산 */
    useEffect(() => {
        // if (!sectionCategory || !thickness || !height) {
        //     return;
        // }
        const _unitWeight = Math.ceil((factor * (sectionCategory * thickness * height * 1000 * 7.85)) / 1000000);
        setUnitWeight(_unitWeight);
    }, [factor, height, sectionCategory, thickness]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!unitWeight || !length) {
        //     return;
        // }
        const _weight = Math.ceil(unitWeight * length);
        setWeight(_weight);
    }, [length, unitWeight]);

    /* 마지막 deckingPlate ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newSideCover.length) {
            return 0;
        }
        return Math.max(...newSideCover.map((item) => Number(item.id.substring(3))), 0);
    }, [newSideCover]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`SC-${getLastId() * 1 + 1}`);
        setSectionCategory('');
        setUnitWeight('');
        // setFactor('');
        setLength('');
        setWeight('');
    }, [getLastId]);

    /* 전체 길이 계산 함수 */
    const getTotalLength = useCallback(() => {
        const _totalLength = newSideCover.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.length);
        }, 0);
        setTotalLength(_totalLength);
    }, [newSideCover]);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback(() => {
        const _totalWeight = newSideCover.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, [newSideCover]);

    /* 추가 버튼을 누르면 newSideCover에 sideCover 추가 */
    const onAddItem = useCallback(() => {
        if (!length || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const _sideCover = {
            // id: countRef.current,
            id,
            sectionCategory: sectionCategoryText.current[sectionCategory],
            thickness,
            unitWeight,
            factor,
            length,
            weight,
        };
        setNewSideCover(newSideCover.concat(_sideCover));
        setIsChanged(true);
    }, [id, sectionCategory, thickness, unitWeight, factor, length, weight, newSideCover]);

    /* 삭제 버튼을 누르면 해당 item 삭제 */
    const onDeleteItem = useCallback(
        (id) => {
            setNewSideCover(newSideCover.filter((item) => item.id !== id));
            setIsChanged(true);
        },
        [newSideCover],
    );

    /* 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalLength(newSideCover);
        getTotalWeight(newSideCover);
        initializeForm();
        onSaveStructure({
            key: 'sideCover',
            value: newSideCover,
        });
        onChangeWeightSummary({
            key: 'sideCover',
            value: {
                totalLength,
                totalWeight,
            },
        });
    }, [
        getTotalLength,
        getTotalWeight,
        initializeForm,
        newSideCover,
        onChangeWeightSummary,
        onSaveStructure,
        totalLength,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveSideCover = useCallback(() => {
    //     onSaveStructure({
    //         key: 'sideCover',
    //         value: newSideCover,
    //     });
    //     onChangeWeightSummary({
    //         key: 'sideCover',
    //         value: {
    //             totalLength,
    //             totalWeight,
    //         },
    //     });
    // }, [newSideCover, onChangeWeightSummary, onSaveStructure, totalLength, totalWeight]);

    /* 변경 사항을 취소하면 newSideCover를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewSideCover(initialSideCover.current);
    //     onSaveStructure({
    //         key: 'sideCover',
    //         value: initialSideCover.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'deckingPlate',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <SideCoverFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Side Cover</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalLength} m2</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Section Type</th>
                                <th>
                                    Thickness
                                    <br />
                                    (mm)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit W't <br />
                                    (kg/m)
                                </th>
                                <th>
                                    Length <br /> (m)
                                </th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newSideCover &&
                                newSideCover.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.sectionCategory}</td>
                                        <td>{item.thickness}</td>
                                        <td>{item.factor}</td>
                                        <td>{item.unitWeight}</td>
                                        <td>{item.length}</td>
                                        <td>{item.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteItem(item.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="sectionCategory"
                                                value="1"
                                                onChange={(e) => setSectionCategory(e.target.value)}
                                            />
                                            <span>Single Side</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="sectionCategory"
                                                value="2"
                                                onChange={(e) => setSectionCategory(e.target.value)}
                                            />
                                            <span>Both Side</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <div className="input-radio">
                                        <select value={thickness} onChange={(e) => setThickness(e.target.value)}>
                                            <option value="1.6">1.6mm</option>
                                            <option value="2.0">2.0mm</option>
                                            <option value="2.3">2.3mm</option>
                                            <option value="3.0">3.0mm</option>
                                            <option value="3.2">3.2mm</option>
                                            <option value="4.0">4.0mm</option>
                                            <option value="4.5">4.5mm</option>
                                            <option value="5.0">5.0mm</option>
                                            <option value="6.0">6.0mm</option>
                                        </select>
                                    </div>
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="input.."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="input.."
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddItem}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Side Cover Total</td>
                                <td>{totalLength}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveSideCover} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </SideCoverFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const SideCoverFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 1rem;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;
const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    // color: ${palette.cyan[8]};
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default SideCoverForm;
